import { render, staticRenderFns } from "./studentProgramsGraduationRequirement.vue?vue&type=template&id=1f06c0a8"
import script from "./studentProgramsGraduationRequirement.vue?vue&type=script&lang=js"
export * from "./studentProgramsGraduationRequirement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports